import { profile } from '@myap/ui-library'
import { getRequest } from '../utils/fetchOperations'

const fetchSchoolsByDICode = async (searchFor, maxSuggestions = 10) => {
  const { orgcdsConfig } = profile()
  // console.log(`fetchSchoolsByDICode searchFor: ${searchFor}`)
  const searchTerm = Number.isNaN(parseInt(searchFor, 10)) /* || code.length !== 4 */
    ? { name: searchFor }
    : { dicode: searchFor }
  // console.log(`fetchSchoolsByDICode searchTerm: ${searchTerm}`)
  const headers = new Headers({
    'Content-Type': 'application/json',
    // 'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1,private',
    // Pragma: 'no-cache',
    // Expires: 0,
    'X-Api-Key': orgcdsConfig.apiKey,
  })
  try {
    const data = await getRequest({
      url: `${orgcdsConfig.url}/disearch`,
      params: { ...searchTerm, ap_pgm: 'y' },
      credentials: 'omit',
      // mode: 'no-cors',
      headers,
    })
    const {
      hits: { total, hits },
    } = data
    const suggestions = hits
      .filter(({ _source: h }) => h.di_code)
      .map(({ _source: h }) => ({
        dicode: h.di_code,
        name: h.org_full_name,
        city: h.org_city,
        state: h.org_state_cd,
        country: h.org_country_iso_cd,
        address: h.org_street_addr1,
        zip: h.org_zip5,
        postal: h.org_intl_postal_code,
        activeInd: h.di_ap_pgm_active_ind === 'Y', // Indicate whether DI is active
      }))
      .slice(0, maxSuggestions)
    const filteredTotal = suggestions.length
    return {
      total: filteredTotal,
      suggestions,
    }
  } catch (err) {
    return { suggestions: [], total: 0 }
  }
}

export default fetchSchoolsByDICode
